import { useState } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import i18n from "../../../i18n-config";
import {
  CustomButton,
  CustomPopper,
  CustomUserSelect,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";

interface Props {
  item: any;
  onBlock?: (item: any) => void;
}

function MesAffaireTableRow({ item, onBlock }: Props) {
  const [show, setShow] = useState(false);

  const handleShowOpen = () => setShow((prev) => !prev);

  return (
    <StyledTableRow
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        cursor: "pointer",
      }}
    >
      <StyledTableCell style={{ color: "#9BA69C" }}>{item.id}</StyledTableCell>
      <StyledTableCell>{item.titre}</StyledTableCell>
      <StyledTableCell>{`${item?.boss?.nom || ""} ${
        item?.boss?.prenom || ""
      }`}</StyledTableCell>
      <StyledTableCell>{item.categorie?.libelle}</StyledTableCell>
      <StyledTableCell>{i18n.t(item.statutSpecifique)}</StyledTableCell>
      <StyledTableCell style={{ justifyContent: "flex-end", display: "flex" }}>
        <CustomPopper
          icon={
            <CustomButton
              title={i18n.t("reaffecter")}
              rootStyle={{ backgroundColor: "#FF7900" }}
            />
          }
          onClose={handleShowOpen}
        >
          <Stack sx={{ width: "320px", height: "450px", alignItems: "center" }}>
            <Typography color="#3D423F" fontWeight={600}>
              {i18n.t("list_charge_affaire")}
            </Typography>

            <Divider sx={{ width: 150, mt: 1, mb: 4 }} />
            <CustomUserSelect title="Francis KOUADIO" checked={false} />
            <CustomUserSelect title="Francis KOUADIO" checked={false} />
            <CustomUserSelect title="Francis KOUADIO" checked={false} />

            <Divider sx={{ width: 100, mt: 5 }} />
            <CustomButton
              title={i18n.t("valider")}
              rootStyle={{ marginTop: 3 }}
            />
          </Stack>
        </CustomPopper>
      </StyledTableCell>
    </StyledTableRow>
  );
}

export default MesAffaireTableRow;
